import React from "react";
import CodeEditorMock from "./CodeEditorMock";
import { useNavigate } from "react-router-dom";

const BioPanel = () => {
  const navigate = useNavigate();
  return (
    <div className="biopanel">
      <div className="file-info">
        <div className="cell file-name">
          <i className="fa-solid fa-folder"> </i>
          bio
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">
        <CodeEditorMock>
          I'm <span class="light-header-text op-1">Mert Arinci</span>, a
          passionate{" "}
          <span class="string-color-text op-1">Full-Stack Developer</span> from
          Izmir and based in{" "}
          <span className="text-underline">Rotterdam, the Netherlands.</span>{" "}
          With expertise in both front-end and back-end technologies, I create
          robust, scalable, and user-friendly web applications.
          <br /> <br />I am experienced with several programming languages and
          frameworks, such as <span class="js-color-text op-1">JavaScript</span>
          , <span class="react-color-text op-1">React</span>,{" "}
          <span class="nodejs-color-text op-1">Node.js</span> and{" "}
          <span class="sql-color-text op-1">SQL</span>. My focus is on
          delivering high-quality product for user experience.
          <br /> <br />I am always{" "}
          <span className="purple-text">
            eager to learn new technologies and improve my skills.
          </span>{" "}
          I want to work on cool projects that really help change things in the
          tech world.
          <br /> <br />
          So far, I've built{" "}
          <span className="js-color-text">75+ websites and apps,</span> and I'm
          looking forward to building plenty more!
          <br /> <br />
          You can also{" "}
          <span
            style={{ cursor: "pointer", textDecoration: "underline" }}
            onClick={() => navigate("/ai-chat")}
            className="js-color-text"
          >
            chat with my AI assistant
          </span>{" "}
          to get know me better and ask any questions.
        </CodeEditorMock>
      </div>
    </div>
  );
};

export default BioPanel;
